import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <IndexSection />
        <FeaturesSection />
        <CommentsSection />
        <FAQSection />
        <CardsSection />
        <UpdatesSection />
        <MediaSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}